import React from "react";
import { Box } from '@mui/joy';
import { Pie } from 'src/mtska-frontend-app-component';

const PieAccounting = ({ user, filters, createSliceFilterHandler, handleFilterChange, t }) => {
    return (
        <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
            <Box className="dashboard-menu-item">
                <Pie
                    title={"Distribuzione per Stato Veicolo"}
                    dataProviderName={"statisticsviews/fleetbystatus/aggregated/views_cars_car/status"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    donutWidth={300}
                    handleFilterChange={createSliceFilterHandler('status', handleFilterChange)}
                />
            </Box>

            <Box className="dashboard-menu-item">
                <Pie
                    title={t("Distribuzione per Azienda Proprietario")}
                    dataProviderName={"statisticsviews/fleetbyaccount/aggregated/views_cars_car/_related_account_name"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    donutWidth={300}
                    handleFilterChange={createSliceFilterHandler('_related_account_name', handleFilterChange)}
                />
            </Box>

            <Box className="dashboard-menu-item">
                <Pie
                    title={t("Distribuzione per Marca")}
                    dataProviderName={"statisticsviews/fleetbymake/aggregated/views_cars_car/_related_setup_make"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    donutWidth={300}
                />
            </Box>

            <Box className="dashboard-menu-item">
                <Pie
                    title={t("Distribuzione per Cliente")}
                    dataProviderName={"statisticsviews/fleetbymake/aggregated/views_cars_car/_related_legalEntity_name"}
                    filters={{
                        items: [
                            ...(filters?.items || [])
                        ]
                    }}
                    donutWidth={300}
                />
            </Box>
        </Box>
    )
}

export default PieAccounting